import { makeStyles } from '@mui/styles';
import ApolloSelect from 'apollo-react/components/Select';
import * as shadows from 'apollo-react/shadows';
import React from 'react';

const useStyles = makeStyles(({ palette }) => ({
  inputRoot: {
    borderRadius: 16,
    boxShadow: shadows.shadowLevel1,
    backgroundColor: palette?.primary?.main,
    padding: '0 8px',
    margin: '0 !important',
    height: 32,
    overflow: 'hidden',
    marginTop: -4,
    '&:hover': {
      boxShadow: shadows.shadowLevel2,
    },
    transition: 'box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    '& .MuiInput-input': {
      marginTop: '-4px !important',
    },
  },
  input: {
    backgroundColor: 'inherit !important',
    border: 'none !important',
    color: 'white !important',
    outline: 'none !important',
  },
  selectRoot: {
    height: 32,
    borderRadius: 16,
    backgroundColor: palette?.primary?.main,
  },
  select: {
    border: 'none',
    color: 'white',
    borderRadius: 16,
    '&:focus': {
      borderRadius: 16,
      backgroundColor: 'transparent',
      boxShadow: 'none',
    },
  },
  icon: {
    color: 'white',
    marginRight: 8,
  },
  formControlRoot: {
    width: 'auto',
    margin: 0,
  },
  menuPaper: {
    top: '50px !important',
    borderRadius: '0 0 4px 4px',
  },
}));

const EntitySelect = ({ value, onChange, anchorEl, anchorWidth, children, placeholder }) => {
  const classes = useStyles();

  return (
    <ApolloSelect
      className={classes.formControlRoot}
      InputProps={{
        classes: {
          root: classes.inputRoot,
          input: classes.input,
        },
      }}
      SelectProps={{
        classes: {
          root: classes.selectRoot,
          select: classes.select,
          icon: classes.icon,
        },
        MenuProps: {
          anchorEl,
          classes: {
            paper: classes.menuPaper,
          },
          PaperProps: {
            style: {
              width: anchorWidth,
            },
          },
        },
      }}
      value={children.length ? value : ''}
      onChange={onChange}
      placeholder={placeholder}
    >
      {children}
    </ApolloSelect>
  );
};

export default EntitySelect;
